import { indorsoftRuAPI } from "../indorsoftRuApi"

export const indorIDAuthApiSlice = indorsoftRuAPI.injectEndpoints({
    endpoints: builder => ({
        loginIndorID: builder.mutation<any, any>({
            query: ({ login, password, remember }) => {
                const body = new URLSearchParams();
                body.append('USER_LOGIN', login);
                body.append('USER_PASSWORD', password);
                body.append('TYPE', 'AUTH');
                body.append('AUTH_FORM', 'Y');
                if (remember) body.append('USER_REMEMBER', 'Y');

                return {
                    url: `auth/index.php?login=yes`,
                    method: 'POST',
                    body,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    responseHandler: 'text',
                    validateStatus: (response) => response.statusText === 'Login Redirect (OK)',
                };
            },
        }),
        checkIndorIDAuth: builder.query<{ authorized: boolean }, void>({
            query: () => ({
                url: `auth/index.php`,
                method: 'GET',
                responseHandler: 'text',
            }),
            transformResponse: (_response: any, meta: any, arg) => {
                const statusText = meta?.response?.statusText;
                const isRedirect = statusText === 'Login Redirect (OK)';
                return { authorized: isRedirect };
            },
            keepUnusedDataFor: 0, // Не кэшируем результат, всегда проверяем актуальное состояние
        }),
        logoutIndorID: builder.mutation<void, void>({
            query: () => ({
                url: `auth/index.php?logout=yes`,
                method: 'GET'
            }),
        })
    })
})

export const {
    useLoginIndorIDMutation,
    useCheckIndorIDAuthQuery,
    useLazyCheckIndorIDAuthQuery,
    useLogoutIndorIDMutation,
} = indorIDAuthApiSlice


